import { getMediasVariant } from "~/features/navigation/components/TopBar/HeaderCircle";
import { FetchFCCRecommendedProducts } from "~/features/saleRecommendations/components/FCCRecommendationsSection";
import { PurchasePlaceProvider } from "~/app/analytics/ga/recommendations/RecommendationContexts";

export interface FCCGapProdRecomSectionProps {
  className?: string;
}

export const FCCGapProductRecommendation = (props: FCCGapProdRecomSectionProps) => {
  const role = getMediasVariant();
  const isBusiness = role === "business";

  if (!isBusiness) {
    return null;
  }
  if (!window.SCHA.toggles.fccGapProdsRecommendation) {
    return null;
  }
  return <FetchFCCRecommendedProducts {...props} />;
};

export function createSchaefflerFccRecommendationComponent() {
  return (
    <PurchasePlaceProvider value={"HOME"}>
      <FCCGapProductRecommendation />
    </PurchasePlaceProvider>
  );
}
